import { Button, makeStyles } from '@material-ui/core';
import { PageHeader } from 'pages/CustomerBookingCreate/components/PageHeader';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { STEP_LOCATION, STEP_PERSONAL_DETAILS, STEP_SCHEDULE } from "pages/CustomerBookingCreate/constants";
import { MapBox } from 'components/AddressLocationForm/MapBox';
import { AutocompleteAddress } from 'components/AutocompleteAddress';
import { LocationAutocomplete } from 'components/AddressLocationForm/LocationForm/LocationAutocomplete';
import { useUpdateEffect } from "usehooks-ts";
import AltLocationAutocomplete from 'components/AddressLocationForm/LocationForm/AltLocationAutocomplete';
import { useUserState } from 'services/authentication.service';
import locationsService from 'services/locations.service';
import { AddLocationWithMap } from './AddLocationWithMap';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { bookingState, stepState } from 'pages/CustomerBookingCreate/state';
import { ExistingLocationList } from './ExistingLocationList';
import { toast } from "react-hot-toast";
import { PinDrop } from '@material-ui/icons';
import { useTrackEvent } from 'util/trackEvent';
import { toasterror } from 'util/toasterror';

const useStyles = makeStyles(theme => ({
}));
const ABAltAuthenticatedLocationScreen = (

) => {
  const classes = useStyles()

  const trackEvent = useTrackEvent()

  const setStep = useSetRecoilState(stepState);
  const [loading, setLoading] = useState(true);

  const [title, setTitle] = useState("");
  const [existingLocations, setExistingLocations] = useState(null);

  const { getUser } = useUserState()

  const [addMode, setAddMode] = useState(false);

  const [booking, setBooking] = useRecoilState(bookingState);

  const fetchExistingLocations = useCallback(
    async () => {
      try {
        setLoading(true)
        const user = await getUser()
        const locResult = await locationsService.getUserLocations(user?.client?.id || user?.user?.id, { confirmedOnly: false })
        setExistingLocations(locResult)
        if (locResult?.length === 0) {
          setAddMode(true)
        }
        setLoading(false)
      } catch (error) {
        setLoading(false)
      }
    },
    [],
  );



  useEffect(
    () => {
      fetchExistingLocations()
    }, []
  );

  const processLocation = useCallback(
    async (loc) => {
      setBooking({
        ...booking,
        location: loc
      })
      setStep(STEP_SCHEDULE)
    }, []
  );

  const processNewLocation = useCallback(
    async (loc) => {
      try {
        setLoading(true)
        trackEvent('Create Booking Location Form - Add New Location')
        const newLoc = await locationsService.addClientLocation((await getUser())?.client?.id, loc)
        setBooking({
          ...booking,
          location: newLoc
        })
        setStep(STEP_SCHEDULE)

      } catch (error) {
        toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details)
      } finally {
        setLoading(false)
      }

    }, []
  );

  const renderLocationAction = useCallback(
    () => {
      if (existingLocations?.length > 0) {
        return (
          <Button
            variant='contained'
            color='primary'
            onClick={() => {
              trackEvent(`Create Booking Location Form - Switch Location Mode - ${addMode ? 'Existing' : 'New'}`)
              setAddMode(!addMode)
            }}
          >
            {addMode ? 'Select Existing Location' : 'Add New Location'}
          </Button>
        )
      }
      return null
    }, [addMode, existingLocations]
  );

  const [ctaButtonProps, setCtaButtonProps] = useState(null);
  return (
    <>
      <PageHeader
        backStep={STEP_PERSONAL_DETAILS}
        currentStep={STEP_LOCATION}
        title={addMode ? 'Add New Location' : 'Select From Existing Locations'}
        loading={loading}
        actions={renderLocationAction}
        callToActionButton={
          ctaButtonProps &&
          <Button
            {...ctaButtonProps}
            variant="contained"
            color="primary"
            fullWidth
            startIcon={<PinDrop />}
          />
        }
      >
        {addMode ? (
          <AddLocationWithMap
            onCTARef={(ref) => {
              setCtaButtonProps(ref)
            }}
            onSwitchToExistingMode={() => {
              setAddMode(false)
            }}
            onConfirmNewLocation={(loc) => {
              processNewLocation(loc)
            }}
          />
        ) : (
          <ExistingLocationList
            onCTARef={(ref) => {
              setCtaButtonProps(ref)
            }}
            onSwitchToAddMode={() => {
              setAddMode(true)
            }}
            onConfirmLocation={(loc) => {
              processLocation(loc)
            }}
            locations={existingLocations}
          />
        )}


      </PageHeader>
    </>
  )
}

export { ABAltAuthenticatedLocationScreen }